import { render, staticRenderFns } from "./ModalIframe.vue?vue&type=template&id=7f27a686&scoped=true&"
import script from "./ModalIframe.vue?vue&type=script&lang=ts&"
export * from "./ModalIframe.vue?vue&type=script&lang=ts&"
import style0 from "./ModalIframe.vue?vue&type=style&index=0&id=7f27a686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f27a686",
  null
  
)

export default component.exports